module.exports = __webpack_public_path__ + "static/media/18-2.33e9fdbb.mp3";